import { getAvailableTitles } from '@/arise/api';
import { Title } from '@/models/profile';

// For storing earned titles as IDs in local storage
export const LS_TITLES = 'ARISE_TITLES';

export function addLocalUserTitle(id: string): void {
    // Get the localstorage array of title IDs and add a new ID to it
    try {
        if (!id || typeof id !== 'string') return;

        const titles = getLocalUserTitleIds();
        if (!titles.includes(id)) {
            titles.push(id);
            localStorage.setItem(LS_TITLES, JSON.stringify(titles));
        }
    } catch (error) {
        console.error('Could not add local title ', error);
    }
}

function getLocalUserTitleIds(): string[] {
    // Get the localstorage array of title IDs and return it
    try {
        const storedTitles = localStorage.getItem(LS_TITLES);
        const titles = storedTitles ? JSON.parse(storedTitles) : [];
        return Array.isArray(titles) && titles.every((item) => typeof item === 'string') ? titles : [];
    } catch {
        return [];
    }
}

export function setLocalUserTitles(titles: Title[]) {
    // Replace the local storage title IDs with a new array
    try {
        if (Array.isArray(titles) && titles.length) {
            // Convert array of titles to array of title IDs
            const ids = titles.map((title) => title.id);
            localStorage.setItem(LS_TITLES, JSON.stringify(ids));
        }
    } catch (error) {
        console.error('Could not set local user titles ', error);
    }
}

export async function getLocalUserTitles(): Promise<Title[]> {
    // Get local title IDs, hydrate them into full Titles and return as array
    try {
        const localIds = getLocalUserTitleIds();
        const availableTitles = await getAvailableTitles();
        return availableTitles.filter((title) => localIds.includes(title.id));
    } catch (error) {
        return [];
    }
}
